var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UploadCsv',_vm._g({attrs:{"parser":_vm.parser,"api-call":_vm.PaymentAdequacy.uploadAccountsAdhoc}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }